<div class="toast" [id]="'type_'+ data.type" [@flyInOut]="{value: animationState, params:
        { fadeIn: toastConfig.animation.fadeIn, fadeOut: toastConfig.animation.fadeOut }}"
        (@flyInOut.done)="onFadeFinished($event)" (click)="close()">
        <div [class]="data.type + '-toastr'" id="toastr-icon"></div>
        <div class="toastr-text">{{ data.text }}</div>
</div>